module.exports = __webpack_public_path__ + "img/appAsset-brand--Office365.af85afc8.svg";